import React from 'react';
import { Box, Typography, Paper, Container } from '@mui/material';
import { colors } from '../theme/themeConfig';
import ConstructionIcon from '@mui/icons-material/Construction';

interface MaintenancePageProps {
  message: string;
}

const MaintenancePage: React.FC<MaintenancePageProps> = ({ message }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: colors.background.default,
        padding: 2,
      }}
    >
      <Container maxWidth="sm">
        <Paper
          elevation={3}
          sx={{
            padding: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            borderRadius: 2,
          }}
        >
          <ConstructionIcon
            sx={{
              fontSize: 100,
              color: colors.warning.main,
              marginBottom: 3,
            }}
          />
          
          <Typography variant="h5" component="h1" gutterBottom align="center" fontWeight="bold">
            Технические работы
          </Typography>
          
          <Typography variant="body1" align="center" paragraph>
            {message || 'Сейчас нерабочее время магазина. Пожалуйста, попробуйте позже.'}
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
};

export default MaintenancePage;
